import { makeAutoObservable } from 'mobx'
import { ToastOptions } from './types'

class ToastStore {
	public showAlert: boolean = false
	public alertInfo: ToastOptions = {}
	private blockingNewAlerts: boolean = false

	constructor() {
		makeAutoObservable(this)
	}

	public useAlert(newAlert: ToastOptions) {
		if (this.blockingNewAlerts) {
			return
		}
		this.alertInfo = newAlert
		this.showAlert = true
		this.blockingNewAlerts = true
		setTimeout(() => this.clearAlert(), 5000)
	}

	public clearAlert() {
		this.alertInfo = {}
		this.showAlert = false
		this.blockingNewAlerts = false
	}
}

export const toastStore: ToastStore = new ToastStore()
export const useAlert = toastStore.useAlert.bind(toastStore)
export const useClearAlert = toastStore.clearAlert.bind(toastStore)
